export const maxGcrFileSize = 100 * 1024 * 1024;
